<div class="container">
   
    
    <div id="orgviewModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
      
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              
              <h6 class=" h6">{{ 'orgview.title' | trans }}</h6>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
            <img class="card-img-top shadow logurl-img" src="{{org?.logourl}}">

            <ul class="list-group list-group-flush">
              <li class="list-group-item">{{org.orgdesc}}</li>
              <li class="list-group-item"> 
                {{org.www}} {{org.email}}
                </li>
              <li class="list-group-item">
                {{org.country}} {{org.city}} {{org.zip}}<br/>
                 {{org.address}} {{org.address2}}</li>
            </ul>
            </div>
            <div class="modal-footer">

            </div>
          </div>
        </div>    
    </div>
      
</div>
   
